// extracted by mini-css-extract-plugin
export default {"sponsors":"sponsor_sponsors__2PG9x","tba":"sponsor_tba__iB5TO"};